import styled from "@emotion/styled";

const CompanyPolicyStyle = styled.div({
  "& .update_policy_btn": {
    borderColor: "#244DA0",
    backgroundColor: "#244DA0",
    borderRadius: "2px",
    color: "white",
    fontWeight: "500",
    float: "right",
    marginRight: "4px",
    textTransform: 'none',
  },
  "& .update_policy": {
    borderColor: "#244DA0",
    backgroundColor: "#244DA0",
    borderRadius: "2px",
    color: "white",
    fontWeight: "500",
    float: "right",
    marginTop: "93px",
    marginRight: "4px",
    textTransform: 'none',
  },
  "& .addScroll": {
    overflowY: "scroll",
    height: "calc(100vh - 200px)",
    marginTop: "15px",
  },

  "& .Title_div": {
    display: "flex",
    justifyContent: "left",
    marginTop: "5px",
    alignItems: 'center'
  },

  "& .Select_role": {
    width: "150px",
    marginLeft: '50px',
    marginBottom: '10px',
    boxShadow: 'rgba(149, 157, 165, 0.18) 2px 4px 17px',
    fontFamily: 'ImportedMilliardSemibold'
  },

  "& .view_policy_title": {
    display: 'flex',
    justifyContent: 'space-between',
    margin: "5px 0px",
    alignItems: 'center',
  },

  "& .TagPolicy": {
    marginLeft: "30px",
    width: 'max-content',
  },

  "& .policy_footer_btn": {
    display: 'flex',
    marginTop: '92px',
    justifyContent: 'space-between',
  },

  '@media screen and (max-width: 600px) and (min-width: 300px)': {
    "& .view_policy_title": {
      display: 'grid',
      gridTemplateColumns: 'auto',
    },
    "& .Title_div": {
      display: 'grid',
      gridTemplateColumns: 'auto auto',
      marginBottom: '10px'
    },
    "&  .Select_role": {
      marginLeft: '10px',
    },
    "& .TagPolicy": {
      marginLeft: "0px",
    },
  },

  '@media screen and (max-width: 480px) and (min-width: 300px)': {
    "& .Title_div": {
      display: 'grid',
      gridTemplateColumns: 'auto',
      marginBottom: '10px'
    },
    "& .TagPolicy": {
      marginLeft: "0px",
    },
    "& .policy_footer_btn": {
      flexDirection: 'column'
    },
  },

  '@media screen and (max-width: 730px) and (min-width: 540px)': {
    "& .policy_footer_btn": {
      marginTop: "150px !important",
    },
  },
  '@media screen and (max-width: 539px) and (min-width: 300px)': {
    "& .policy_footer_btn": {
      marginTop: "230px !important",
    },
  },

});

export default CompanyPolicyStyle;
